import { IContact } from 'clickNgo/entities/contact'
import { I375Form } from 'clickNgo/models/crud/forms/i375Form'

export const map375FromContact = (contact: IContact): I375Form => ({
  EntryId: contact.entryId375,
  CountryOfBusiness: contact.countryOfBusiness,
  Email: contact.email,
  FirstName: contact.firstName,
  LastName: contact.lastName,
  MobilePhone: contact.mobilePhoneNumber,
  MobilePhone_Prefix: contact.mobilePhoneCode,
  NeverCall: contact.isNeverCall ? 'Y' : 'N',
  NeverEmail: contact.isNeverEmail ? 'Y' : 'N',
  NewPartnerID: contact.newPartnerId,
  RelinkingComment: contact.relinkingComment,
  PartnerID: contact.partnerId,
  PR_HP_ROLE: contact.hpRoles.join(';'),
  PreferredLanguage: contact.preferredLanguage,
  Salutation: contact.salutation,
  Seniority: contact.seniority,
  Status: contact.status,
  WorkPhone: contact.workPhoneNumber,
  WorkPhone_Prefix: contact.workPhoneCode,
  ModifiedValues: contact.modifiedValues.join(','),
  ProfileTeamComment: contact.profileTeamComment,
  WorkflowStatus: contact.workflowStatus,
  ContactID: contact.contactId,
  PrimaryJobRole: contact.primaryJobRole.join(';'),
  Market: contact.market,
  Source: contact.source,
  SourceRequestor: contact.sourceRequester,
  AppId: contact.appId,
  OnboardingRequestId: contact.onboardingRequestId,
})
